// native
import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

// service
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class DisableForClinicalTrialReadOnlyNoPiiGuard {
  constructor(
    private router: Router,
    private authService: AuthService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.authService.isClinicalTrialReadOnlyNoPii) {
      return true;
    }
    return this.router.createUrlTree(['/patients']);
  }
}
